import { render, staticRenderFns } from "./EditableContentBlock.vue?vue&type=template&id=74a7856d&"
import script from "./EditableContentBlock.vue?vue&type=script&lang=js&"
export * from "./EditableContentBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports